<template>
  <section>
    <div class="z-card border-0 integration-page">
      <h4>{{ $t('integration.api.send_single_messages') }}</h4>

      <div class="z-card__body">
        <article class="mb-5">
          <ul class="list-unstyled integration-list-info">
            <li><b>URL:</b> https://my.zorra.com/api/v1/mailing/single/send</li>
            <li><b>Content-Type:</b> application/json</li>
            <li><b>Method:</b> POST</li>
            <li><b>Body:</b> JSON</li>
            <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
          </ul>
          <p>{{ $t('integration.api.send_message_limit') }} <b>3000</b></p>
          <p>{{ $t('integration.api.example') }}</p>
          <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"type"</span>: <span class="hljs-string">"sms"</span>,
      <span class="hljs-attr">"sender"</span>: <span class="hljs-string">"Dostavim"</span>,
      <span class="hljs-attr">"body"</span>: <span class="hljs-string">"hello"</span>,
      <span class="hljs-attr">"recipient"</span>: <span class="hljs-string">"79991112233"</span>
  }

</code>
        </pre>
          <p>
            {{ $t('integration.api.request_send_messages') }}
          </p>
          <ul class="list-unstyled integration-list-info">
            <li v-html="$t('integration.api.on_phone_number')"></li>
          </ul>
        </article>
        <article class="mb-5">
          <h4>{{ $t('integration.api.send_messages_group') }}</h4>
          <ul class="list-unstyled integration-list-info">
            <li><b>URL:</b> https://my.zorra.com/v1/mailing/send</li>
            <li><b>Content-Type:</b> application/json</li>
            <li><b>Method:</b> POST</li>
            <li><b>Body:</b> JSON</li>
            <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
          </ul>
          <p>{{ $t('integration.api.send_message_limit') }} <b>10</b></p>
          <p>{{ $t('integration.api.example') }}</p>

          <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"type"</span>: <span class="hljs-string">"sms"</span>,
      <span class="hljs-attr">"sender"</span>: <span class="hljs-string">"Dostavim"</span>,
      <span class="hljs-attr">"body"</span>: <span class="hljs-string">"hello"</span>,
      <span class="hljs-attr">"recipients"</span>: [
          <span class="hljs-string">"7987654321"</span>,
          <span class="hljs-string">"7999111223"</span>
      ]
  }

</code>
            </pre>
          <p v-html="$t('integration.api.limit_recipients')"></p>
        </article>

        <article class="mb-5">
          <h4>{{ $t('integration.api.recipients_macros') }}:</h4>
          <p>{{ $t('integration.api.macros_replace_recipient') }}</p>

          <p>{{ $t('integration.api.example') }}</p>

          <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"type"</span>: <span class="hljs-string">"sms"</span>,
      <span class="hljs-attr">"sender"</span>: <span class="hljs-string">"Dostavim"</span>,
      <span class="hljs-attr">"body"</span>: <span class="hljs-string">"Hello, {name}!"</span>,
      <span class="hljs-attr">"recipients"</span>: [
          {<span class="hljs-attr">"number"</span>:<span class="hljs-string">"7987654321"</span>, <span class="hljs-attr">"name"</span>: <span class="hljs-string">"Adam"</span>},
          {<span class="hljs-attr">"number"</span>:<span class="hljs-string">"8999222333"</span>, <span class="hljs-attr">"name"</span>: <span class="hljs-string">"Alex"</span>},
          <span class="hljs-string">"79991112233"</span>
          ]
  }

</code>
        </pre>
          <p>{{ $t('integration.api.request_send_messages') }}</p>

          <ul class="list-unstyled integration-list-info">
            <li>
              &laquo;Hello, Adam!&raquo; {{ $t('integration.api.on_phone_number') }} 7987654321
            </li>
            <li>
              &laquo;Hello, Alex!&raquo; {{ $t('integration.api.on_phone_number') }} 8999222333
            </li>
            <li>
              &laquo;Hello, !&raquo; {{ $t('integration.api.on_phone_number') }} 79991112233 ({{
                $t('integration.api.not_specify_name_field')
              }})
            </li>
          </ul>
        </article>

        <article class="mb-5">
          <h4>{{ $t('integration.api.list_macros') }}:</h4>

          <pre>
<code class="json hljs">
  name
  email
  first_name
  last_name
  age
  sex
  country
  city
  custom<span class="hljs-number">1</span>
  custom<span class="hljs-number">2</span>
  custom<span class="hljs-number">3</span>
  custom<span class="hljs-number">4</span>
  custom<span class="hljs-number">5</span>
</code>
        </pre>
        </article>

        <article class="mb-5">
          <h4>{{ $t('integration.api.combined_sending') }}:</h4>
          <p>{{ $t('integration.api.optional_element_custom_message') }}</p>
          <p>{{ $t('integration.api.example') }}</p>

          <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"type"</span>: <span class="hljs-string">"sms"</span>,
      <span class="hljs-attr">"sender"</span>: <span class="hljs-string">"Dostavim"</span>,
      <span class="hljs-attr">"body"</span>: <span class="hljs-string">"Hello, {name}!"</span>,
      <span class="hljs-attr">"recipients"</span>: [
          {<span class="hljs-attr">"number"</span>:<span class="hljs-string">"7987654321"</span>, <span class="hljs-attr">"custom_message"</span>: <span class="hljs-string">"Greetings!"</span>},
          {<span class="hljs-attr">"number"</span>:<span class="hljs-string">"8999222333"</span>, <span class="hljs-attr">"name"</span>: <span class="hljs-string">"Samuelle"</span>},
          <span class="hljs-string">"79991112233"</span>
      ]
  }

</code>
        </pre>
          <p v-html="$t('integration.api.limit_recipients')"></p>

          <ul class="list-unstyled integration-list-info">
            <li>
              &laquo;Greetings!&raquo; {{ $t('integration.api.on_phone_number') }} 7987654321,
              {{ $t('integration.api.because_recipient_hard') }} <b>custom_message</b>,
            </li>
            <li>
              &laquo;Hello, Samuelle!&raquo; {{ $t('integration.api.on_phone_number') }} 8999222333,
            </li>
            <li>
              &laquo;Hello, !&raquo; {{ $t('integration.api.on_phone_number') }} 79991112233
              {{ $t('integration.api.not_specify_name_field') }}).
            </li>
          </ul>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
  export default {};
</script>
<style lang="scss">
  @import '~@/assets/styles/scss/highlight/monokai';
  @import '~@/assets/styles/scss/pages/integration';
</style>
